/**
 * @file: 商品文字模式渲染
 * @author: xiaolong.huang@dmall.com
 */

import * as UIToolkit from '../../../UIToolkit/index';
import * as Toolkit from '../../../toolkit/index';
import * as FrontCubeData from '../../../frontCubeData/index';
import Config from '../../../config/index';
import RenderData, { SubGoodsRenderData } from './renderData';

export interface MainGoodsTxtRenderData {
    fontSize: number,
    goodSize: Size,
    txtStr: string,
    txtArr: Array<string>
}

export interface SubGoodsTxtRenderData {
    brandColor: string,
    titleList: Array<string>,
    fontSize: number
}

// 主商品文字模式渲染
export function mainGoodsTxt(cube: CubeNode): void {
    let $container: JQuery<HTMLElement> = cube.jView.find('.default-tags');
    
    let txtRenderData: MainGoodsTxtRenderData = createMainGoodsTxtRenderData(cube);

    $container
        .attr('title', txtRenderData.txtStr)
        .css({
            fontSize: txtRenderData.fontSize,
            display: txtRenderData.txtArr.length > 0 ? 'block' : 'none'
        });
}

export function createMainGoodsTxtRenderData(cube: CubeNode): MainGoodsTxtRenderData {
    let txtArr: Array<string> = createMainGoodsTxtList(cube);
    let txtStr: string = txtArr.join('/');
    let goodSize: Size = UIToolkit.onlyCenterGoodsSize(cube);
    let fontSize: number = Toolkit.computeFontSize({
        continerWidth: Toolkit.cmToPx(goodSize.width),
        continerHeight: Toolkit.cmToPx(goodSize.height),
        strLength: txtStr.length,
        maxFontSize: Number.MAX_VALUE
    });

    return {
        fontSize,
        goodSize,
        txtStr,
        txtArr
    }
}

function createMainGoodsTxtList(cube: CubeNode): Array<string> {
    let tagList: FreeObjMap = Config.getGlobalConfig('TAG_LIST');
    let tagListMap: FreeObjMap = Config.getGlobalConfig('TAG_LIST_MAP');
    let result: Array<string> = [];

    for (var i = 0; i < tagList.length; i++) {
        let tag: FreeObjMap = tagList[i];
        if (tag.typeId === 0 || tag.typeId === 3) {
            continue;
        }
        let id: string = tag.id ? `${tag.typeId}-${tag.categoryId}-${tag.id}` : `${tag.typeId}-${tag.categoryId}`;
        let key: FreeObjMap = tagListMap[id];
        if (key === undefined || FrontCubeData.getValue(cube.id, key.objKey) === undefined) {
            continue;
        }
        let val: string = FrontCubeData.getValue(cube.id, key.objKey);

        result.push(key.fieldName + ':' + (val != null ? val : " ") + (key.fieldUnit ? key.fieldUnit : ''));
    }

    return result;
}

// 字码商品文字模式渲染
export function subGoodsTxt(cube: CubeNode): void {
    // 构建字码商品渲染数据
    let subGoodsRenderData: SubGoodsRenderData = RenderData.subGoods(cube);
    let subSkuList: Array<SkuData> = subGoodsRenderData.subSkuList;

    subSkuList.forEach((sku, index) => {
        if (index === 0) {
            return;
        }
        let $container: JQuery<HTMLElement> = cube.jView.find(`.sub_${index}`);
        let subGoodsTxtRenderData: SubGoodsTxtRenderData = createSubGoodsTxtRenderData(sku);
        let titleStr: string = subGoodsTxtRenderData.titleList.join('/');
        
        $container
            .attr('title', titleStr)
            .css({
                fontSize: subGoodsTxtRenderData.fontSize,
                display: subGoodsTxtRenderData.titleList.length > 0 ? 'block' : 'none',
                color: subGoodsTxtRenderData.brandColor
            });
        Toolkit.html($container, titleStr);
    });
}

export function createSubGoodsTxtRenderData(sku: SkuData): SubGoodsTxtRenderData {
    let brandColor: string = '#000';
    let titleList: Array<string> = creatSubGoodsTxtList(sku);
    let titleStr: string = titleList.join('/');
    let fontSize: number = Toolkit.computeFontSize({
        continerWidth: Toolkit.cmToPx(sku.width),
        continerHeight: Toolkit.cmToPx(sku.height),
        strLength: titleStr.length + 4,
        maxFontSize: Number.MAX_VALUE
    });

    return {
        brandColor,
        titleList,
        fontSize
    }
}

// 字码商品title组装
function creatSubGoodsTxtList(sku: SkuData): Array<string> {
    let result: Array<string> = [];
    let tagList: FreeObjMap = Config.getGlobalConfig('TAG_LIST');
    let tagListMap: FreeObjMap = Config.getGlobalConfig('TAG_LIST_MAP');

    for (var i = 0; i < tagList.length; i++) {
        let tag: FreeObjMap = tagList[i];

        if (tag.typeId == 0 || tag.typeId == 3) {
            continue;
        }
        let id: string = tag.id ? `${tag.typeId}-${tag.categoryId}-${tag.id}` : `${tag.typeId}-${tag.categoryId}`;
        let key: FreeObjMap = tagListMap[id];

        if (key === undefined || sku[key.objKey] === undefined) {
            continue;
        }

        let val: any = sku[key.objKey];

        result.push(key.fieldName + ':' + (val != null ? val : " ") + (key.fieldUnit ? key.fieldUnit : ''));
    }

    return result;
}
